export default class SolicitudNotificacionBalanceModel {
  image: string;
  title: string;
  description: string;
  note: string;
}
